import { gql } from '@apollo/client';

export const GET_PAGINATED_PRODUCT_STATISTICS = gql`
    query GetPaginatedProductStatistics(
      $offset: Int,
      $limit: Int,
      $productName: String,
      $dateFromTo: DateFromTo,
      $quantitySortOrder: SortOrder,
      $revenueSortOrder: SortOrder,
      $markupSort: SortOrder
      $foodCostSort: SortOrder
    ) {
      productStatistics(
        offset: $offset,
        limit: $limit,
        productName: $productName,
        dateFromTo: $dateFromTo,
        quantitySortOrder: $quantitySortOrder,
        revenueSortOrder: $revenueSortOrder,
        markupSort: $markupSort
        foodCostSort: $foodCostSort
      ) {
        items {
          id
          quantity
          revenue
          productName
          foodCost
          markup
          netRevenue
          primeCost
        }
        count
      }
    }
`;

export const GET_PRODUCTS_REPORT = gql`
    query GetProductsReport($dateFromTo: DateFromTo) {
      productsReport(dateFromTo: $dateFromTo)
    }
`;

export const GET_POHODA_ISSUE_SLIP = gql`
    query PohodaIssueSlip($dateFromTo: DateFromTo) {
      pohodaIssueSlip(dateFromTo: $dateFromTo)
    }
`;

export const GET_CATEGORY_STATISTICS = gql`
    query CategoriesStatistics($dateFromTo: DateFromTo) {
      categoriesStatistics(dateFromTo: $dateFromTo) {
        id
        categoryId
        name
        quantity
        grossRevenue
        netRevenue
        color
        foodCost
        netMargin
        productWithNoRecipeCount
        primeCost
      }
  }
`;

export const GET_TABLE_STATISTICS = gql`
  query TableStatistics($dateFromTo: DateFromTo) {
    tableStatistics(dateFromTo: $dateFromTo) {
      id
      placeName
      sectionName
      sectionId
      billCount
      grossRevenue
    }
  }
`;